import { Outlet } from 'react-router-dom';
import { useScrollToTop } from '@/hooks/useScrollToTop';
import { Header } from '@/components/layout/Header';
import { Footer } from '@/components/layout/Footer';
import styles from './RootLayout.module.css';

/** App shell: header, routed page content, and footer. */
export function RootLayout() {
  useScrollToTop();

  return (
    <div className={styles.shell}>
      <a href="#main" className={styles.skipLink}>
        Skip to content
      </a>
      <Header />
      <main id="main" className={styles.main}>
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
